import { IComponentOptions } from "angular";
import { LoginPageController } from "./controller";

export const vsComponentName = "login";

export const loginPageComponentOptions: IComponentOptions = {
  controller: LoginPageController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    returnState: "<",
  },
};
